<template>
  <div>
    <div
      v-dompurify-html="highlightAirport(value)"
      class="airport"
    />
    <div
      v-dompurify-html="highlightCityAndCountry(value)"
      class="country-container"
    />
  </div>
</template>

<script>
  import HighlightUtils from 'utils/HighlightUtils'
  import TypeaheadItem from 'components/eHorizon/Typeahead/Item'

  export default {
    extends: TypeaheadItem,
    methods: {
      highlightAirport(value) {
        let aptCode = ''

        if (value.apt !== null && typeof value.apt !== 'undefined') {
          aptCode = value.apt

          if (value.code !== null && typeof value.code !== 'undefined') {
            aptCode = `${aptCode}, (${value.code})`
          }
        }

        return HighlightUtils.highlight(aptCode, this.filter)
      },
      highlightCityAndCountry(value) {
        let city = ''
        let country = ''

        if (value.city !== null && typeof value.city !== 'undefined') {
          city = value.city + ', '
        }

        if (value.country !== null && typeof value.country !== 'undefined') {
          country = value.country
        }
        return HighlightUtils.highlight(city + country, this.filter)
      }
    }
  }
</script>

<style
  lang="scss"
  scoped
  rel="stylesheet/scss"
>
  @import '~assets/styles/common.scss';

  .airport {
    font-size: em(15);
    color: $grey-default;

    ::v-deep b {
      font-weight: 500;
    }

    .selected & {
      color: $blue-medium;
    }
  }

  .country-container {
    width: 100%;
    font-size: em(13);
    color: $input-placeholder;
    margin-top: 5px;

    .selected & {
      color: rgba(49, 56, 146, 0.5);
    }
  }
</style>
